export const SET_CONTACT_POINT_INFO_ID = 'SET_CONTACT_POINT_INFO_ID';
export const SET_CONTACT_POINT_INFO_EMAIL = 'SET_CONTACT_POINT_INFO_EMAIL';
export const SET_STATUS_TO_CONTACT_CHANGE = 'SET_STATUS_TO_CONTACT_CHANGE';
export const SET_SALES_CONTACT_EMAIL = 'SET_SALES_CONTACT_EMAIL';
export const SET_CAREER_FORM_DATA = 'SET_CAREER_FORM_DATA';
export const SET_JOB_INFORMATION_HIDDEN = 'SET_JOB_INFORMATION_HIDDEN';
export const SET_DROPDOWN_FORMS = 'SET_DROPDOWN_FORMS';
